import { defineStore } from "pinia";
import router from "./../router";

const ruta_api = process.env.VUE_APP_ROOT_API;

export const useAuth = defineStore({
  id: "auth",
  state: () => ({
    token: localStorage.getItem("token") || "",
    sessionToken: localStorage.getItem("session_token") || "",
    user: JSON.parse(localStorage.getItem("user")),
    returnUrl: null,
    sessionTerminated: false,
  }),

  getters: {
    isAuthenticated: (state) => !!(state.token && state.user),
  },

  actions: {
    async userLogin(data) {
      const res = await fetch(ruta_api + "/login", {
        method: "POST",
        body: JSON.stringify({ login: data.login, password: data.password }),
        headers: { "Content-Type": "application/json" },
      });

      const output = await res.json();

      if (output.success) {
        localStorage.setItem("token", output.token);
        localStorage.setItem("session_token", output.session_token);

        this.token = output.token;
        this.sessionToken = output.session_token;
        this.user = output.user;
        this.user.permissions = output.permissions;
        localStorage.setItem("user", JSON.stringify(output.user));

        const permissions = output.permissions || {};

        const esAdmin =
          "Usuario Listar" in permissions || "Rol Listar" in permissions;

        const tieneAccesoCocina =
          "Cocina Ver Pedidos" in permissions ||
          "Cocina MarcarListo" in permissions;

        const tieneAccesoMesas =
          "Mesa Listar" in permissions ||
          "Pedido Crear" in permissions ||
          "Restaurante GenerarCuenta" in permissions;

        if (esAdmin) {
          router.push(this.returnUrl || "/");
        } else if (tieneAccesoCocina) {
          router.push({ name: "cocina" });
        } else if (tieneAccesoMesas) {
          router.push({ name: "restaurante_plano_mesas" });
        } else {
          router.push(this.returnUrl || "/");
        }
      } else {
        throw new Error(output.mensaje || "Error al iniciar sesión");
      }
    },

    handleRemoteLogout() {
      this.sessionTerminated = true;

      localStorage.removeItem("token");
      localStorage.removeItem("session_token");
      localStorage.removeItem("user");

      // Forzar recarga completa
      setTimeout(() => {
        window.location.href = "/#/login?reason=session_terminated";
      }, 100);
    },

    async getUser() {
      const res = await fetch(ruta_api + "/user", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
          "X-Session-Token": this.sessionToken,
        },
      });

      if (!res.ok) {
        throw new Error("No autenticado");
      }

      const output = await res.json();
      this.user = output.user;
    },

    userLogout() {
      this.token = "";
      this.sessionToken = "";
      this.user = null;

      localStorage.removeItem("token");
      localStorage.removeItem("session_token");
      localStorage.removeItem("user");

      router.push({ name: "login" });
    },

    resetSessionTerminated() {
      this.sessionTerminated = false;
    },
  },
});
